class SpanDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.configure(event.detail))
    document.addEventListener('spans-did-change', (event) => this.configure(event.detail)) 
  }

  configure(project) {
    let str = "<table class='table table-borderless'>";
    for(let i = 0; i < project.beam.spans.length; i++ ) {
        str += `<tr><td style='width:100px;'>Span ${i + 1}</td>`
        str += `<td><input style='width:100px;' id='span_input_${i}' type='text'`
        str += `value='${showLengthWithUnits(project.beam.spans[i].length(), true)}' onchange='onSpanLengthChange(${i});'/></td>`
        if(project.beam.spans.length > 1) {
            str += `<td><button type='button' class='btn btn-sm btn-danger' onclick='removeSpan(${i});'>Remove</button></td>`
        }
        str += "</tr>"
    }
    str += "</table>";

    document.getElementById('span-table').innerHTML = str
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-span-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Edit Spans</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body modal-body-shadow">
            <div class="panel panel-warning d-none" id="design-available-warning">
              <div class="panel-heading" id="span-dialog-warning-text"></div>
            </div>
            <div class="text-center">  
              <button id="add-left-span-button" type="button" class="btn btn-primary button-shadow btn-md">
                Add Left Span
              </button>
              <button id="add-right-span-button" type="button" class="btn btn-primary button-shadow btn-md">
                Add Right Span
              </button>
            </div>
          </div>

          <div class="modal-body">
            <div id="span-table"></div>
            <div class="alert alert-info" role="alert">
              <strong>Pro tip!</strong> Support Conditions can be changed by clicking on them in the drawing.
            </div>
          </div>  
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    `
  }

}

customElements.define('span-dialog-component', SpanDialogComponent)

function removeSpan(index) {
  document.dispatchEvent(new CustomEvent('remove-span', {detail: index}))
}

function openModalSpanDialog(index) {
  //put cursor in this input box if the id has been passed in
  if( typeof index !== 'undefined'){
    document.getElementById(`span_input_${index}`).focus()
  }
  bootstrap.Modal.getOrCreateInstance('#modal-span-dialog').show()
}

window.openModalSpanDialog = openModalSpanDialog

function onSpanLengthChange(index) {
  document.dispatchEvent(new CustomEvent('span-length-changed', {detail: index}))
}